import { Component, TemplateRef, Type, input, output } from '@angular/core';

import {
  CamAddEventRequest,
  CamCalendarComponent,
  CamCalendarEventModel,
  CamTimeRangeModel,
  CamUpdateEventRequest,
} from '@camelot/calendar';

import { CamEventCardComponent } from '../card/card.component';

@Component({
  selector: 'cam-planning-calendar',
  imports: [CamCalendarComponent],
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
export class CamPlanningCalendarComponent {
  planningId = input.required<string>();

  events = input.required<CamCalendarEventModel[]>();

  timeRanges = input.required<CamTimeRangeModel[]>();

  addEventTemplate = input.required<TemplateRef<unknown>>();

  cardComponent = input<Type<{ event: unknown }>>(CamEventCardComponent);

  addEventRequest = output<CamAddEventRequest>();

  updateEventRequest = output<CamUpdateEventRequest>();

  public eventRequest(event: CamAddEventRequest) {
    this.addEventRequest.emit(event);
  }
  public eventUpdateRequest(event: CamUpdateEventRequest) {
    this.updateEventRequest.emit(event);
  }
}
